import { router } from '@inertiajs/react'

import AddLeadersForm from '../features/manage-leaders/AddLeadersForm'
import { Card } from '@layouts'
import RemoveLeadersForm, { type Leader } from '../features/manage-leaders/RemoveLeadersForm'
import AppErrorsAlert from '@molecules/Alerts/AppErrorsAlert'
import BackLink from '@molecules/BackLink'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('group_edit.manage_leaders')

type PropsType = {
  group: {
    id: string
    leaders: {
      nodes: any[]
    }
  }
}

export default function ManageLeaders({ group }: PropsType) {
  const leaders: Leader[] = group.leaders.nodes.map((leader) => ({
    id: leader.id,
    fullName: leader.fullName,
    email: leader.email,
    role: leader.userRoles.nodes[0]?.role?.name,
  }))

  const reloadLeaders = ({ onFinish }: { onFinish: () => void }) => router.reload({ only: ['group'], onFinish })

  return (
    <div className="tw:px-16 tw:py-16 tw:min-h-screen">
      <Card title={'Manage Leaders'} backgroundFill={true} className={'tw:px-12 tw:py-5'}>
        <AppErrorsAlert errorsPath="manageLeaders" />
        <RemoveLeadersForm groupID={group.id} leaders={leaders} onLeadersChanged={reloadLeaders} />
        <AddLeadersForm groupID={group.id} onLeadersChanged={reloadLeaders} />
      </Card>

      <div className="tw:w-full tw:flex tw:justify-center tw:pt-10">
        <BackLink to={`/groups/${group.id}`} color="primary" rank="secondary" leadingIcon="arrow-narrow-left">
          {t('back_to_group')}
        </BackLink>
      </div>
    </div>
  )
}
